// extracted by mini-css-extract-plugin
export default {"resourceTimeline":"resourceTimeline--Zi_0Z"};